export default "__VITE_ASSET__D9XT_JDQ__"